<template>
  <div class="small-12 medium-12 large-12 columns candidatura_al">
    <div class="row margintop">
      <div class="small-12 medium-12 large-3 columns">
        <h1>{{ concurso.Tipo.label }}</h1>
      </div>
      <div class="small-12 medium-6 large-3 columns">
        <h2>{{ $t('UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS') }}</h2>
        <p v-for="destinatario in destinatarios">
          {{ destinatario }}
        </p>
      </div>
      <div class="small-12 medium-6 large-3 columns">
        <h2>{{ $t('UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_PRAZOCANDIDATURA') }} :</h2>
        <p v-if="concurso.Fases.length == 0" 
          v-for="p in prazocandidatura">
          {{ p }}
        </p>
        <p v-for="fase in concurso.Fases">
          <template v-if="fase.isOpen">
            {{ fase.Fase }} -
            {{ $t('UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_DE') }} {{ fase.DataInicio }}
            {{ $t('UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_A') }} {{ fase.DataFim }}
          </template>
          <template v-if="!fase.isOpen">
            {{ fase.Fase }} - {{ $t("UMA_LANG_SASUMA_ALOJAMENTO_INFOADISPONIBILIZAR") }}
          </template>
        </p>
      </div>
      <div class="small-12 medium-12 large-3 columns">
        <a
          :class="{ 'isDisabled': !concurso.Activo }"
          :disabled="!concurso.Activo"
          :event="!concurso.Activo ? '' : 'click'"
          @click="goToForm">
            {{ $t('UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_SUBMETERCANDIDATURA') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { i18n } from "@/main.js";
import { useRouter } from "vue-router";
import { useFormStore } from '@/stores/form.js'


export default {
  props: ["concurso"],
  setup(props) {

    const { t } = i18n.global;
    const lang = i18n.global.locale;
    const lg = lang == "en" ? "/en" : "";

    const label = ref("");
    const destinatarios = ref([]);

    const { Tipo, DataFim, DataInicio } = props.concurso;

    switch (Tipo.value) {
      case 'internacional':
        destinatarios.value = [t('UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_EI')];
        break;
      case 'recandidaturas':
        destinatarios.value = [
          t('UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_EUB'),
          t('UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_EUD'),
          t('UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_EOUTROS'),
        ];
        break;
      case 'novosalunos':
        destinatarios.value = [
          t('UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_EUB'),
          t('UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_EUD')
        ];
        break;
      case 'mobilidade':
        destinatarios.value = [
          t('UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_EMOBILIDADE')
        ];
        break;
      case 'outros':
        destinatarios.value = [
          t('UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_OUTROS')
        ];
        break;
      default:
        break;
    }

    const prazocandidatura = ref([
      t('UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_SEMPREDISPONIVEL')
    ]);


    const setPrazoCandidatura = () => {
      if(Tipo.value != 'outros'){
        prazocandidatura.value = [
          `${t('UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_DE')} ${DataInicio} ${t('UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_A')} ${DataFim}`
        ]
      }
    }

    setPrazoCandidatura()

    const router = useRouter();

    const store = useFormStore();

    const goToForm = () => {

      store.setCurrentForm(Tipo.value);

      if(props.concurso.Activo){
        router.push({
          name: 'alojamentoForm'
        });
      }
    }

    return {
      goToForm,
      prazocandidatura,
      label,
      destinatarios
    }
  }
}
</script>

<style lang="scss" scoped>
.candidatura_al {
  background-color: #fcfcff;
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: 8px;
  box-shadow:
    0px 0px 0px rgb(0 0 0 / 1%),
    inset 0px 0px 0px rgb(0 0 0 / 2%),
    0px 0px 0px rgb(0 0 0 / 2%),
    0px 0px 20px rgb(0 0 0 / 2%),
    0px 0px 33.4px rgb(0 0 0 / 3%),
    inset 0px 0px 0px 0px rgb(0 0 0 / 4%);
}

a:hover {
  box-shadow: 0 2.8px 2.2px rgb(0 0 0 / 1%), 0 6.7px 5.3px rgb(0 0 0 / 2%), 0 12.5px 10px rgb(0 0 0 / 2%), 0 22.3px 17.9px rgb(0 0 0 / 2%), 0 41.8px 33.4px rgb(0 0 0 / 3%), 0 100px 80px rgb(0 0 0 / 4%);
  background-color: #54b2ce;
}

.margintop {
  margin-top: 30px;
}

h1 {
  font-family: "Montserrat";
  font-size: 25px;
  color: #408fa7;
  padding-left: 15px;
}

h2 {
  font-family: "Montserrat";
  font-size: 18px;
  padding-top: 5px;
  color: #337e95;
}

p {
  font-family: "Montserrat Light";
  margin-bottom: 2px;
  color: #494d52eb;
}

p:last-of-type {
  margin-bottom: 35px;
}

a {
  background-color: #4a9db6;
  color: white;
  font-family: Montserrat;
  border-radius: 5px;
  display: inline-block;
  margin-top: 9px;
  padding: 16px 25px 15px;
}

a.isDisabled {
  background-color: #acacad;
}

@media (max-width: 1500px) and (min-width: 1370px) {
  h1 {
    font-size: 27px;
  }

  .margintop .columns {
    padding-left: 0;
    padding-right: 0;
  }
}

@media (max-width: 1370px) and (min-width: 1000px) {
  .margintop .columns:first-of-type {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .margintop .columns:first-of-type h1 {
    padding-left: 0;
    margin-bottom: 28px;
  }

  .margintop .columns:not(:first-of-type) {
    max-width: 33.333333%;
    flex: 0 0 33.333333%;
  }
}

@media (max-width: 1024px) {
  .margintop {
    margin-top: 0;
  }

  a {
    display: block;
    padding-left: 0;
    padding-right: 0;
    margin-bottom: 25px;
    margin-top: 0;
    text-align: center;
    font-size: 15px;
  }

  p {
    font-size: 15px;
  }

  h1 {
    font-size: 25px;
    padding: 25px 0 20px;
  }
}

@media (max-width: 767px) {

  .margintop {
    margin-top: 10px;
  }

  .noticiabackgroundcolor h1,
  h1 {
    font-size: 25px;
    padding: 25px 0 20px;
  }

  h2 {
    padding-top: 0;
    font-size: 15px;
  }

  .candidatura_al .columns:last-of-type {
    margin-top: 0;
  }

  a {
    display: block;
    padding-left: 0;
    padding-right: 0;
    margin-bottom: 25px;
    margin-top: 0;
    text-align: center;
    font-size: 15px;
  }

  p {
    font-size: 14px;
  }

}

@media (max-width: 767px) {

  p:last-of-type {
    margin-bottom: 15px;
  }

  h1 {
    font-size: 18px;
    font-family: "Montserrat Semibold";
    padding-top: 14px;
    padding-bottom: 12px;
    text-align: center;
  }

  h2 {
    color: #30393c;
  }
}
</style>